export default __webpack_public_path__ + "static/media/prev-airdockz.993d8b15.jpg";